import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/balloon-loan-calculator',
  component: () => import('../../routes/BalloonLoan.svelte'),
  card: {
    id: 'balloon-loan',
    title: 'Balloon Loan Calculator',
    description: 'Calculate monthly payments and final balloon amount for financing with a large final payment.',
    icon: 'car_rental',
    iconBgClass: 'bg-purple-50',
    iconTextClass: 'text-purple-600',
    href: '/balloon-loan-calculator',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Balloon Loan Calculator – Low Monthly Payments with Final Payment',
    description: 'Calculate balloon loan payments with low monthly installments and a large final balloon payment. Compare with standard auto financing.',
  },
};

export default meta;